import React from "react";
import styled from "styled-components";
import ReactTimeout from "react-timeout";
import { H3 } from "./typography";
import { HFlexFlipper } from "./blocks/Flex";
import { r } from "../utils";

const RotatingContainer = styled.span`
  display: inline-grid;
  text-align: left;
  ${props => props.theme.media.card`
    text-align: center;
    justify-items: center;
    min-height: calc(1.875rem * 1.3 * 2);
  `};
`;

const RotatingItem = styled.span`
  grid-area: 1 / 1;
  transition: opacity 400ms ease;
  opacity: ${({ active }) => (active ? 1 : 0)};
`;

const WhatIfWrapper = styled.div`
  width: 100%;
`;

const WhatIfFlipper = HFlexFlipper.extend`
  ${props => props.theme.media.card`
    flex-direction: column;
    align-items: center;
    justify-content: center;
  `};
`;

const WhatIfText = H3.extend`
  padding-bottom: 8rem;
  max-width: 50rem;
  margin: 0 auto;
  padding-left: 4rem;
  ${props => props.theme.media.card`
    max-width: none;
    margin: 0 auto;
    padding-left: 0;
    text-align: center;
    width: 100%;
    display: flex;
    justify-content: center;
  `};
`;

class WhatIf extends React.Component {
  whatIfList = [
    "gave you peace of mind",
    "gave your partner a break",
    "gave you personal freedom",
    "gave you control",
  ];
  state = { index: 0, visible: true };

  componentWillMount() {
    this._startCycle();
  }

  _startCycle() {
    this.props.setTimeout(() => {
      this.setState({ visible: false });
      this.props.setTimeout(() => {
        this.setState(prev => ({
          index: (prev.index + 1) % this.whatIfList.length,
          visible: true,
        }));
        this._startCycle();
      }, 400);
    }, 2700);
  }

  render() {
    const { index, visible } = this.state;
    return (
      <WhatIfWrapper>
        <WhatIfText>
          <WhatIfFlipper>
            What if
            <div style={{ display: "inline-block", padding: "0 .5rem" }}>
              <span style={{ color: "#43bcba" }}> male contraception </span>
            </div>
            <RotatingContainer>
              {this.whatIfList.map((text, i) =>
                <RotatingItem key={text} active={visible && i === index}>
                  {text}?
                </RotatingItem>
              )}
            </RotatingContainer>
          </WhatIfFlipper>
        </WhatIfText>
      </WhatIfWrapper>
    );
  }
}

export default ReactTimeout(WhatIf);



// WEBPACK FOOTER //
// ./src/components/WhatIf.js